document.addEventListener("DOMContentLoaded", function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return "\u00a3" + (cents / 100).toFixed(2);
  }

  var section = document.querySelector("[data-single-product]");
  if (!section) return;

  var gallery = section.querySelector("[data-product-gallery]");
  var thumbs = section.querySelectorAll("[data-product-thumb]");
  var packs = section.querySelectorAll("[data-product-pack]");
  var options = section.querySelectorAll("[data-product-option]");
  var qtyMinus = section.querySelector("[data-product-qty-minus]");
  var qtyPlus = section.querySelector("[data-product-qty-plus]");
  var qtyValue = section.querySelector("[data-product-qty-value]");
  var unitPriceEl = section.querySelector("[data-product-unit-price]");
  var totalEl = section.querySelector("[data-product-total]");
  var optionPriceEl = section.querySelector("[data-product-option-price]");
  var subBadgeEl = section.querySelector("[data-product-sub-badge]");
  var subPriceEl = section.querySelector("[data-product-sub-price]");
  var addBtn = section.querySelector("[data-product-add-to-cart]");
  var sidebarPackLabel = section.querySelector("[data-sidebar-pack-label]");
  var sidebarPackMeta = section.querySelector("[data-sidebar-pack-meta]");
  var sidebarPackPrice = section.querySelector("[data-sidebar-pack-price]");
  var sidebarTotalEl = section.querySelector("[data-product-sidebar-total]");
  var sidebarAddBtn = section.querySelector("[data-product-sidebar-add]");

  var state = {
    variantId: "",
    priceCents: 0,
    qty: 1,
    mode: "onetime",
    sellingPlanId: null,
    sellingPlans: [],
    subDiscount: 0,
    subDiscountType: "percentage",
  };

  var firstPack = section.querySelector(".single-product__pack--active") || packs[0];
  if (firstPack) {
    state.variantId = firstPack.getAttribute("data-variant-id") || "";
    state.priceCents = parseInt(firstPack.getAttribute("data-price-cents"), 10) || 0;
    try {
      state.sellingPlans = JSON.parse(firstPack.getAttribute("data-selling-plans") || "[]");
    } catch (e) {
      state.sellingPlans = [];
    }
  } else {
    var singleVariantInput = section.querySelector("[data-variant-id]");
    if (singleVariantInput) {
      state.variantId = singleVariantInput.getAttribute("data-variant-id") || "";
      state.priceCents = parseInt(singleVariantInput.getAttribute("data-price-cents"), 10) || 0;
    }
  }

  var freqSelect = section.querySelector("[data-product-frequency-select]");

  function rebuildFrequencySelect() {
    if (!freqSelect) return;
    var nativeSelect = freqSelect.querySelector("select");
    var valueEl = freqSelect.querySelector("[data-product-frequency-value]");
    var menu = freqSelect.querySelector("[data-product-frequency-menu]");
    var trigger = freqSelect.querySelector("[data-product-frequency-trigger]");
    if (!nativeSelect) return;

    nativeSelect.innerHTML = "";
    if (menu) menu.innerHTML = "";

    var plans = state.sellingPlans || [];
    if (plans.length === 0) {
      state.sellingPlanId = null;
      state.subDiscount = 0;
      state.subDiscountType = "percentage";
      if (valueEl) valueEl.textContent = "";
      return;
    }

    plans.forEach(function (plan, idx) {
      var opt = document.createElement("option");
      opt.value = plan.id;
      opt.setAttribute("data-discount", plan.price_adj_value || 0);
      opt.setAttribute("data-discount-type", plan.price_adj_type || "percentage");
      opt.textContent = plan.name;
      if (idx === 0) opt.selected = true;
      nativeSelect.appendChild(opt);

      if (menu) {
        var item = document.createElement("li");
        item.className = "single-product__option-select-option" + (idx === 0 ? " single-product__option-select-option--selected" : "");
        item.setAttribute("role", "option");
        item.dataset.value = String(plan.id);
        item.dataset.discount = String(plan.price_adj_value || 0);
        item.dataset.discountType = plan.price_adj_type || "percentage";
        item.textContent = plan.name;
        item.setAttribute("aria-selected", idx === 0 ? "true" : "false");

        item.addEventListener("click", function (event) {
          event.stopPropagation();
          nativeSelect.value = item.dataset.value;
          if (valueEl) valueEl.textContent = item.textContent;
          state.sellingPlanId = item.dataset.value;
          state.subDiscount = parseInt(item.dataset.discount, 10) || 0;
          state.subDiscountType = item.dataset.discountType || "percentage";
          menu.querySelectorAll(".single-product__option-select-option").forEach(function (el) {
            var isSel = el === item;
            el.classList.toggle("single-product__option-select-option--selected", isSel);
            el.setAttribute("aria-selected", isSel ? "true" : "false");
          });
          if (menu) { menu.hidden = true; }
          if (trigger) { trigger.setAttribute("aria-expanded", "false"); }
          updatePrices();
        });

        menu.appendChild(item);
      }
    });

    var first = plans[0];
    state.sellingPlanId = String(first.id);
    state.subDiscount = parseInt(first.price_adj_value, 10) || 0;
    state.subDiscountType = first.price_adj_type || "percentage";
    if (valueEl) valueEl.textContent = first.name;

    if (trigger) {
      trigger.onclick = function (event) {
        event.stopPropagation();
        if (menu) {
          menu.hidden = !menu.hidden;
          trigger.setAttribute("aria-expanded", menu.hidden ? "false" : "true");
        }
      };
    }
  }

  rebuildFrequencySelect();

  function getSubPrice() {
    if (state.subDiscountType === "percentage" && state.subDiscount > 0) {
      return Math.round(state.priceCents * (1 - state.subDiscount / 100));
    }
    if (state.subDiscountType === "fixed_amount" && state.subDiscount > 0) {
      return Math.max(0, state.priceCents - state.subDiscount);
    }
    return state.priceCents;
  }

  function getDisplayPrice() {
    if (state.mode === "subscribe") {
      return getSubPrice();
    }
    return state.priceCents;
  }

  function updatePrices() {
    if (unitPriceEl) unitPriceEl.textContent = formatMoney(state.priceCents);
    if (optionPriceEl) optionPriceEl.textContent = formatMoney(state.priceCents);

    var subPrice = getSubPrice();
    if (subPriceEl) subPriceEl.textContent = formatMoney(subPrice);
    if (subBadgeEl && state.subDiscount > 0) {
      subBadgeEl.textContent = "Save " + state.subDiscount + "%";
    }

    var displayTotal = formatMoney(getDisplayPrice() * state.qty);
    if (totalEl) totalEl.textContent = displayTotal;
    if (sidebarPackPrice) sidebarPackPrice.textContent = formatMoney(state.priceCents);
    if (sidebarTotalEl) sidebarTotalEl.textContent = displayTotal;
  }

  function updateSidebarPack(packEl) {
    if (!packEl) return;
    var label = packEl.getAttribute("data-pack-override") || packEl.getAttribute("data-pack-title") || "";
    var meta = packEl.getAttribute("data-pack-meta") || "";
    if (sidebarPackLabel) sidebarPackLabel.textContent = label;
    if (sidebarPackMeta) sidebarPackMeta.innerHTML = meta;
  }

  function updateQty() {
    if (qtyValue) qtyValue.textContent = String(state.qty);
    if (qtyMinus) qtyMinus.disabled = state.qty <= 1 || state.mode === "subscribe";
    updatePrices();
  }

  function updateQtyLock() {
    var locked = state.mode === "subscribe";
    if (qtyPlus) qtyPlus.disabled = locked;
    if (qtyMinus) qtyMinus.disabled = locked || state.qty <= 1;
  }

  function updateSubscribeAvailability() {
    var subscribeBtn = section.querySelector('[data-product-option="subscribe"]');
    if (!subscribeBtn) return;
    var hasPlans = state.sellingPlans && state.sellingPlans.length > 0;

    subscribeBtn.disabled = !hasPlans;
    subscribeBtn.style.opacity = hasPlans ? "" : "0.4";
    subscribeBtn.style.pointerEvents = hasPlans ? "" : "none";

    if (!hasPlans && state.mode === "subscribe") {
      var onetimeBtn = section.querySelector('[data-product-option="onetime"]');
      if (onetimeBtn) {
        setActiveItem(options, onetimeBtn, "single-product__option--active");
        state.mode = "onetime";
        updateQtyLock();
      }
    }
  }

  function setActiveItem(items, activeItem, activeClass) {
    items.forEach(function (item) {
      var isActive = item === activeItem;
      item.classList.toggle(activeClass, isActive);
      item.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  /* ----- Gallery Swiper ----- */
  if (gallery && typeof Swiper !== "undefined") {
    var swiper = new Swiper(gallery, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      navigation: {
        nextEl: section.querySelector("[data-product-gallery-next]"),
        prevEl: section.querySelector("[data-product-gallery-prev]"),
      },
      on: {
        slideChange: function () {
          setActiveThumb(swiper.activeIndex);
        },
      },
    });

    function setActiveThumb(index) {
      thumbs.forEach(function (thumb, i) {
        var isActive = i === index;
        thumb.classList.toggle("single-product__thumb--active", isActive);
        thumb.setAttribute("aria-current", isActive ? "true" : "false");
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        swiper.slideTo(index);
        setActiveThumb(index);
      });
    });
  }

  /* ----- Pack Selection ----- */
  packs.forEach(function (pack) {
    pack.addEventListener("click", function () {
      if (pack.classList.contains("single-product__pack--active")) return;
      setActiveItem(packs, pack, "single-product__pack--active");

      state.variantId = pack.getAttribute("data-variant-id") || "";
      state.priceCents = parseInt(pack.getAttribute("data-price-cents"), 10) || 0;
      try {
        state.sellingPlans = JSON.parse(pack.getAttribute("data-selling-plans") || "[]");
      } catch (e) {
        state.sellingPlans = [];
      }

      updateSidebarPack(pack);
      rebuildFrequencySelect();
      updateSubscribeAvailability();
      updatePrices();
    });
  });

  /* ----- Purchase Option Toggle ----- */
  options.forEach(function (option) {
    option.addEventListener("click", function (event) {
      if (event.target.closest("[data-product-frequency-select]")) return;
      if (option.classList.contains("single-product__option--active")) return;

      setActiveItem(options, option, "single-product__option--active");
      state.mode = option.getAttribute("data-product-option") || "onetime";

      if (state.mode === "subscribe") {
        state.qty = 1;
        updateQty();
      }
      updateQtyLock();
      updatePrices();
    });
  });

  document.addEventListener("click", function () {
    if (!freqSelect) return;
    var menu = freqSelect.querySelector("[data-product-frequency-menu]");
    var trigger = freqSelect.querySelector("[data-product-frequency-trigger]");
    if (menu) menu.hidden = true;
    if (trigger) trigger.setAttribute("aria-expanded", "false");
  });

  /* ----- Quantity ----- */
  if (qtyMinus && qtyPlus && qtyValue) {
    qtyMinus.addEventListener("click", function () {
      if (state.mode === "subscribe" || state.qty <= 1) return;
      state.qty -= 1;
      updateQty();
    });

    qtyPlus.addEventListener("click", function () {
      if (state.mode === "subscribe") return;
      state.qty += 1;
      updateQty();
    });
  }

  /* ----- Add to Cart ----- */
  if (addBtn) {
    addBtn.addEventListener("click", function () {
      if (!state.variantId) return;

      var body = {
        id: parseInt(state.variantId, 10),
        quantity: state.qty,
      };

      if (state.mode === "subscribe" && state.sellingPlanId) {
        body.selling_plan = parseInt(state.sellingPlanId, 10);
      }

      addBtn.classList.add("single-product__add-btn--loading");
      addBtn.setAttribute("aria-disabled", "true");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Add to cart failed");
          return response.json();
        })
        .then(function () {
          if (window.HappyJoCartDrawer && window.HappyJoCartDrawer.isEnabled()) {
            addBtn.classList.remove("single-product__add-btn--loading");
            addBtn.removeAttribute("aria-disabled");
            return window.HappyJoCartDrawer.openAfterAdd();
          }
          window.location.href = "/cart";
        })
        .catch(function (err) {
          console.error(err);
          addBtn.classList.remove("single-product__add-btn--loading");
          addBtn.removeAttribute("aria-disabled");
        });
    });
  }

  /* ----- Info Tabs ----- */
  var infoRoot = section.querySelector("[data-product-info]");

  if (infoRoot) {
    var infoTabs = infoRoot.querySelectorAll("[data-product-info-tab]");
    var infoPanels = infoRoot.querySelectorAll("[data-product-info-panel]");
    var infoSelectRoot = infoRoot.querySelector("[data-product-info-select]");

    function activateInfoPanel(panelId) {
      infoTabs.forEach(function (tab) {
        var isActive = tab.dataset.productInfoTab === panelId;
        tab.classList.toggle("single-product__info-tab--active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.tabIndex = isActive ? 0 : -1;
      });

      infoPanels.forEach(function (panel) {
        var isActive = panel.dataset.productInfoPanel === panelId;
        panel.classList.toggle("single-product__info-panel--active", isActive);
        panel.hidden = !isActive;
      });

      if (infoSelectRoot) {
        var nativeSel = infoSelectRoot.querySelector("select");
        if (nativeSel) nativeSel.value = panelId;

        var valueEl = infoSelectRoot.querySelector("[data-product-info-value]");
        var activeTab = infoRoot.querySelector('[data-product-info-tab="' + panelId + '"]');
        if (valueEl && activeTab) valueEl.textContent = activeTab.textContent;

        infoSelectRoot.querySelectorAll(".single-product__info-select-option").forEach(function (item) {
          var isSelected = item.dataset.value === panelId;
          item.classList.toggle("single-product__info-select-option--selected", isSelected);
          item.setAttribute("aria-selected", isSelected ? "true" : "false");
        });
      }
    }

    infoTabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activateInfoPanel(tab.dataset.productInfoTab);
      });
    });

    if (infoSelectRoot) {
      var infoTrigger = infoSelectRoot.querySelector("[data-product-info-trigger]");
      var infoValueEl = infoSelectRoot.querySelector("[data-product-info-value]");
      var infoMenu = infoSelectRoot.querySelector("[data-product-info-menu]");
      var infoNative = infoSelectRoot.querySelector("select");

      if (infoTrigger && infoValueEl && infoMenu && infoNative) {
        function closeInfoMenu() {
          infoMenu.hidden = true;
          infoTrigger.setAttribute("aria-expanded", "false");
        }

        Array.from(infoNative.options).forEach(function (option) {
          var item = document.createElement("li");
          item.className = "single-product__info-select-option";
          item.setAttribute("role", "option");
          item.dataset.value = option.value;
          item.textContent = option.textContent;

          if (option.selected) {
            item.classList.add("single-product__info-select-option--selected");
            item.setAttribute("aria-selected", "true");
          } else {
            item.setAttribute("aria-selected", "false");
          }

          infoMenu.appendChild(item);
        });

        infoTrigger.addEventListener("click", function (event) {
          event.stopPropagation();
          infoMenu.hidden = !infoMenu.hidden;
          infoTrigger.setAttribute("aria-expanded", infoMenu.hidden ? "false" : "true");
        });

        infoMenu.addEventListener("click", function (event) {
          var optionEl = event.target.closest(".single-product__info-select-option");
          if (!optionEl) return;
          event.stopPropagation();
          activateInfoPanel(optionEl.dataset.value);
          closeInfoMenu();
        });

        document.addEventListener("click", function () {
          closeInfoMenu();
        });
      }
    }
  }

  /* ----- Sidebar Add to Cart ----- */
  if (sidebarAddBtn) {
    sidebarAddBtn.addEventListener("click", function () {
      if (addBtn) addBtn.click();
    });
  }

  /* ----- Flavours scroll progress ----- */
  var flavoursScroll = section.querySelector("[data-product-flavours-scroll]");
  var flavoursProgress = section.querySelector("[data-product-flavours-progress]");
  var flavoursProgressFill = section.querySelector("[data-product-flavours-progress-fill]");

  if (flavoursScroll && flavoursProgress && flavoursProgressFill) {
    function updateFlavoursProgress() {
      var scrollWidth = flavoursScroll.scrollWidth;
      var clientWidth = flavoursScroll.clientWidth;
      var maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        flavoursProgress.hidden = true;
        return;
      }

      flavoursProgress.hidden = false;

      var thumbWidth = (clientWidth / scrollWidth) * 100;
      var scrollRatio = flavoursScroll.scrollLeft / maxScroll;

      flavoursProgressFill.style.width = thumbWidth + "%";
      flavoursProgressFill.style.left = scrollRatio * (100 - thumbWidth) + "%";
    }

    flavoursScroll.addEventListener("scroll", updateFlavoursProgress, { passive: true });
    window.addEventListener("resize", updateFlavoursProgress);
    updateFlavoursProgress();
  }

  /* ----- Init ----- */
  var activePack = section.querySelector(".single-product__pack--active") || packs[0];
  if (activePack) updateSidebarPack(activePack);

  rebuildFrequencySelect();
  updateSubscribeAvailability();
  updateQty();
  updatePrices();
});
